module.exports = __webpack_public_path__ + "static/media/a-01.2b936ddc.jpg";